import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/Home";
import Error from "./pages/Error";
import Main from "./pages/Main";
import Category from "./pages/Category";
import Voice from "./pages/Voice";
import Store, { storeLoader } from "./pages/Store";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />,
        errorElement: <Error />,
    },
    {
        path: "/main",
        element: <Main />,
        errorElement: <Error />,
    },
    {
        path: "/category",
        element: <Category />,
        errorElement: <Error />,
    },
    {
        path: "/voice",
        element: <Voice />,
        errorElement: <Error />,
    },
	{
		path: "/store/:name",
		element: <Store />,
		errorElement: <Error />,
		loader: storeLoader,
	},
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
